module.exports = __webpack_public_path__ + "img/news-card.6abe058c.jpg";